module.exports = __webpack_public_path__ + "img/bg_w.0726df0c.png";